import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../redux/messages";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import CustomNavbar from "../../components/CustomNavbar";
// import SidebarCapacitacion from "../../components/capacitacionDesarrollo/SidebarCapacitacion";
import SidebarDashboard from "../../components/SidebarDashboard";
//
import CalendarCampaigns from "../../components/capacitacionDesarrollo/CalendarCampaigns";
import { Tab, Tabs } from "react-bootstrap";

//redux
import {
  deleteCampaigns,
  editCampaigns,
  getCampaigns,
  saveCampaigns,
} from "../../redux/capacitacionDesarrollo/campaigns/actions";

const Campaigns = (props) => {
  const schema = Yup.object().shape({
    nombre_campania: Yup.string().ensure().required("**Campo requerido"),
    codigo_campania: Yup.string().ensure().required("**Campo requerido"),
  });

  const userRoles = useSelector((store) => store.auth.userRoles);
  const isJefeOnly =
    userRoles.includes("jefe") &&
    !userRoles.includes("administrador") &&
    !userRoles.includes("Responsable_Capacitacion");

  const {
    loaderCampaigns,
    campaigns,
    campaignsFail,
    saveLoaderCampaigns,
    campaignsFormError,
  } = useSelector((store) => store.campaigns);

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [activeView, setActiveView] = useState(
    isJefeOnly ? "calendar" : "table"
  );
  //
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  const filters = [
    { id: "nombre_campania", desc: "Ruta" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  const pages = Math.ceil(campaigns ? campaigns.count / limit : 0);

  //Datos custom table
  const columns = [
    {
      Header: "Código",
      accessor: "codigo_campania",
    },
    {
      // Header: "Campaña/rutas",
      Header: "Rutas",
      accessor: "nombre_campania",
    },
    {
      Header: "Fecha de inicio",
      //   accessor: "fecha_inicio",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_inicio
            ? moment(value.row.original.fecha_inicio).format("DD/MM/YYYY")
            : "No hay eventos"}
        </div>
      ),
    },
    {
      Header: "Fecha de finalización",
      //accessor: "fecha_fin",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.fecha_fin
            ? moment(value.row.original.fecha_fin).format("DD/MM/YYYY")
            : "No hay eventos"}
        </div>
      ),
    },
    {
      Header: "Duración de horas",
      //accessor: "duracion_horas",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.duracion_horas
            ? value.row.original.duracion_horas
            : "No hay eventos"}
        </div>
      ),
    },
    {
      Header: "Estado:",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${
            value.row.original.list_estado[0].descripcion === "Abierto"
              ? "bg-success text-light"
              : // : value.row.original.list_estado[0].descripcion === "Proceso"
              // ? "bg-secondary text-light"
              value.row.original.list_estado[0].descripcion === "Cerrado"
              ? "bg-danger text-light"
              : "bg-secondary text-light"
          } p-2 rounded-pill text-center`}
          style={{
            minWidth: "90px",
          }}
        >
          {value.row.original.list_estado[0].descripcion}
        </div>
      ),
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group d-flex" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            disabled={
              value.row.original.list_estado[0].descripcion
                ? value.row.original.list_estado[0].descripcion !== "Abierto"
                : ""
            }
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            disabled={
              value.row.original.list_estado[0].descripcion !== "Abierto"
            }
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          <Button
            onClick={() =>
              history.push(
                `/capacitacion-desarrollo/eventos-capacitacion/${value.row.original.id}/${value.row.original.nombre_campania}/${value.row.original.codigo_campania}`
              )
            } // cambiar a la pantalla de eventos de capacitacion
            variant="link"
            className="font-weight-bold text-dark"
          >
            <i className="material-icons">arrow_right_alt</i>
          </Button>
        </div>
      ),
    },
  ];

  //methods
  const _getCampaigns = (offs = offset, lim = limit, filt = filter, id) =>
    dispatch(
      getCampaigns({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
        // tipo_busqueda_2: "id",
        // filter_2: filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, index) => {
    if (isJefeOnly) {
      toastr.warning("No tienes permisos para esta acción");
      return;
    }
    // Resto de la lógica...
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCampaigns(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getCampaigns(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    const exist = campaigns.data.find(
      (e) => e.codigo_campania === req.codigo_campania
    );
    if (exist && !edit) {
      toastr.info("El codigo ya existe.");
      return;
    }
    // const _req = {
    //   estado: req.estado_descripcion,
    //   codigo: req.codigo_campania,
    //   nombre_campania: req.nombre_campania,
    //   duracion: req.duracion_horas,
    //   fecha_actualizacion: req.fecha_actualizacion,
    //   fecha_fin: req.fecha_fin,
    //   fecha_inicio: req.fecha_inicio,
    // };
    if (!edit) {
      dispatch(saveCampaigns(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editCampaigns(req, index, setShowFormModal));
    }
  };

  useEffect(() => {
    _getCampaigns();
  }, []);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              RUTAS DE CAPACITACIÓN
            </h5>
            {activeView === "table" && (
              <Form onSubmit={onSearch}>
                <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                  <Col>
                    <h6>
                      <b>Búsqueda por: {tipoBusqueda.desc}</b>
                    </h6>
                  </Col>
                  <Col xs="auto">
                    <Form.Control
                      name="filter"
                      type="search"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                    ></Form.Control>
                  </Col>
                  <Col xs="auto">
                    <ButtonGroup>
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded-pill mr-1"
                        onClick={() => seeAll()}
                      >
                        <i className="material-icons">list</i>
                      </Button>
                      {!isJefeOnly && (
                        <Button
                          variant="light"
                          size="sm"
                          className="rounded-pill"
                          onClick={() => onAdd()}
                        >
                          <i className="material-icons">add</i>
                        </Button>
                      )}
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className="mx-1">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                    </ButtonGroup>
                  </Col>
                </Form.Row>
              </Form>
            )}
          </div>
          {!!campaignsFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {campaignsFail}
            </Alert>
          )}
          <Tabs
            activeKey={activeView}
            onSelect={(k) => !isJefeOnly && setActiveView(k)}
            className="mb-3"
            id="campaigns-view-tabs"
          >
            <Tab eventKey="table" title="Campañas" disabled={isJefeOnly}>
              {loaderCampaigns ? (
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    role="status"
                    className="d-flex justify-content-center"
                  />
                </div>
              ) : campaigns != null && campaigns.data.length > 0 ? (
                <>
                  <Card className="border-0">
                    <Card.Body className="px-1 px-sm-2">
                      <CustomTable columns={columns} data={campaigns.data} />
                    </Card.Body>
                  </Card>
                  <CustomPagint
                    limit={limit}
                    setLimit={setLimit}
                    offset={offset}
                    setOffset={setOffset}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    dataLenght={campaigns.count}
                    pages={pages}
                    pagFunc={_getCampaigns}
                  />
                </>
              ) : (
                <Alert variant="info" className="my-4">
                  Aún no hay registros, comience creando algunos.
                </Alert>
              )}
            </Tab>
            <Tab eventKey="calendar" title="Calendario de Capacitaciones">
              {loaderCampaigns ? (
                <div className="d-flex justify-content-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <CalendarCampaigns
                  onEventClick={(event) => {
                    history.push(
                      `/capacitacion-desarrollo/eventos-capacitacion/${event.id}/${event.title}`
                    );
                  }}
                />
              )}
            </Tab>
          </Tabs>
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              codigo_campania: edit ? editItem.codigo_campania : "",
              nombre_campania: edit ? editItem.nombre_campania : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Ruta" : "Crear Ruta"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {campaignsFormError &&
                  typeof campaignsFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {campaignsFormError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Código
                    </Form.Label>
                    <Form.Control
                      name="codigo_campania"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.codigo_campania}
                      placeholder="Código"
                      onBlur={handleBlur("codigo_campania")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.codigo_campania && !!errors.codigo_campania
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.codigo_campania}
                    </Form.Control.Feedback>
                    {campaignsFormError &&
                    typeof originsFormError === "object" &&
                    campaignsFormError.codigo_campania ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {campaignsFormError.codigo_campania.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre de ruta
                    </Form.Label>
                    <Form.Control
                      name="nombre_campania"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre_campania}
                      placeholder="Nombre de campaña"
                      onBlur={handleBlur("nombre_campania")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.nombre_campania && !!errors.nombre_campania
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_campania}
                    </Form.Control.Feedback>
                    {campaignsFormError &&
                    typeof originsFormError === "object" &&
                    campaignsFormError.nombre_campania ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {campaignsFormError.nombre_campania.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderCampaigns}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderCampaigns && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default Campaigns;
